import { Schema } from "@generation/core";
import { translate } from "@klantondersteuning/shared";
import { IPageFlowStep } from "@shared/shared-generic-rekenmodule";
import { useAtom } from "jotai";
import { klantContactResultAtom } from "../../../../atom/KlantContactResultAtom";
import { resultsStep } from "./resultsStep";
const summaryAndSendStepName = "NakijkenEnVersturen";
export const summaryAndSendStep = (firstFlowStep: IPageFlowStep): IPageFlowStep => {
  const [_, setklantContactResult] = useAtom(klantContactResultAtom);
  const getSchema = (variables: any): (() => Schema) => {
    let schema: Schema = firstFlowStep.getSchema(variables)();
    let nextFlowStep = firstFlowStep.nextFlowStep;
    while (nextFlowStep && nextFlowStep.name != summaryAndSendStepName) {
      schema = { ...schema, ...nextFlowStep.getSchema(variables)() };

      nextFlowStep = nextFlowStep.nextFlowStep;
    }
    return () => schema;
  };

  return {
    name: summaryAndSendStepName,
    categoryName: translate("Klantondersteuning_Formulieren_NakijkenEnVersturen"),
    isReadOnly: true,
    getSchema: getSchema,
    // Removing this causes issues with the klantondersteuning stepper as it doesn't expect the nextflow steps to be a function yet.
    // When that is added to the overal logic, nextFlowStep: resultsStep can be removed.
    // The function which doesnt support it yet is getAllPageFlowSteps but more issues may arise.
    nextFlowStep: resultsStep,
    getNextFlowStep: (_) => {
      // When the user goes from the overview to the result step, clear the response from potential previous form submissions.
      setklantContactResult(false);
      return Promise.resolve(resultsStep);
    },
    resultStepNextBtnLabel: translate("Klantondersteuning_Formulieren_Verzenden"),
    customClass: "form-step-summary"
  };
};
